// extracted by mini-css-extract-plugin
export var container = "_ni-0";
export var dotAnimation = "_ni-2";
export var dotsLoading = "_ni-1";